module.exports = __webpack_public_path__ + "static/media/1.c01710d8.jpeg";